<template>
  <span style="margin-right: 5px">
    <el-button :type="type" :size="size" @click="rejectBeneficiary()">
      Reject
    </el-button>

    <el-dialog
      title="Reject this beneficiary?"
      :visible.sync="dialogReject"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="rejectForm" :model="formData" :rules="rules" size="mini">
        <el-form-item label="Status">
          <el-tag type="danger">Reject </el-tag>
        </el-form-item>
        <el-form-item label="Reason" prop="reason">
          <el-input type="textarea" v-model="formData.reason"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogReject = false">Cancel</el-button>
        <el-button
          type="primary"
          @click="updateStatus()"
          :loading="submitting"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </span>
</template>

<script>
import { getToken } from "@/utils/auth";
import {
  updateStatusBeneficiary,
} from "@/api/beneficiary-monitor";
export default {
 
  props: {
    uid: {
      type: String,
      default: "",
    },
    info: Object,
    type: {
      type: String,
      default: "danger",
    },
    size: {
      type: String,
      default: "mini",
    },
  },
  data() {
    return {
      dialogReject: false,
      formData: {
        reason: "",
      },
      rules: {
        reason: [
          {
            required: true,
            message: "Please input reason",
            trigger: "blur",
          },
          { min: 6, message: "Length should be more than 6", trigger: "blur" },
        ],
      },
      submitting: false,
      
    };
  },
  methods: {
    rejectBeneficiary() {
  
      this.dialogReject = true;
      this.submitting = false;
    },

    updateStatus() {
      var model = {
        status: "reject",
        reason: this.formData.reason,
      };
      this.$refs.rejectForm.validate((valid) => {
        if (valid) {
          this.submitting = true;
          updateStatusBeneficiary(this.uid, model).then(
            ({ result, message }) => {
              this.submitting = false;
              if (result) {
                this.$emit("onSuccess");
                this.dialogReject = false;
                this.formData.reason = "";
                this.$notify({
                  title: "Success",
                  message: `Update successfully`,
                  type: "success",
                  duration: 2000,
                });
              } else {
                this.$notify({
                  title: "Error",
                  message: message,
                  type: "error",
                  duration: 2000,
                });
              }
            }
          );
        }
      });
    },
   
  },
  mounted() {
    
  },
};
</script>

<style>
</style>